import React from 'react';
import Card from "../Card/Card";
import CardBody from "../Card/CardBody";
import CardText from "../Card/CardText";
import DeletedNote from "./DeletedNote";
import EditableNote, { EditableNoteDefaultProps } from "./EditableNote";
import NoteHeader from "./NoteHeader";
var defaultProps = {
  className: 'mb-3',
  dateFormat: 'ddd, MMMM D, YYYY "at" h:mm A',
  showTimezone: true,
  rows: EditableNoteDefaultProps.rows,
  saving: EditableNoteDefaultProps.saving,
  saveLabel: EditableNoteDefaultProps.saveLabel,
  savingLabel: EditableNoteDefaultProps.savingLabel
};

var Note = function Note(_ref) {
  var children = _ref.children,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? defaultProps.className : _ref$className,
      _ref$dateFormat = _ref.dateFormat,
      dateFormat = _ref$dateFormat === void 0 ? defaultProps.dateFormat : _ref$dateFormat,
      _ref$showTimezone = _ref.showTimezone,
      showTimezone = _ref$showTimezone === void 0 ? defaultProps.showTimezone : _ref$showTimezone,
      _ref$rows = _ref.rows,
      rows = _ref$rows === void 0 ? defaultProps.rows : _ref$rows,
      _ref$saving = _ref.saving,
      saving = _ref$saving === void 0 ? defaultProps.saving : _ref$saving,
      _ref$saveLabel = _ref.saveLabel,
      saveLabel = _ref$saveLabel === void 0 ? defaultProps.saveLabel : _ref$saveLabel,
      _ref$savingLabel = _ref.savingLabel,
      savingLabel = _ref$savingLabel === void 0 ? defaultProps.savingLabel : _ref$savingLabel,
      note = _ref.note,
      onCancel = _ref.onCancel,
      onChange = _ref.onChange,
      onDelete = _ref.onDelete,
      onEdit = _ref.onEdit,
      onSave = _ref.onSave,
      onUndelete = _ref.onUndelete;
  var deleted = note.deleted,
      editing = note.editing,
      text = note.text;

  if (deleted) {
    return /*#__PURE__*/React.createElement(DeletedNote, {
      className: className,
      note: note,
      onUndelete: onUndelete
    });
  }

  if (editing && onCancel && onChange && onSave) {
    return /*#__PURE__*/React.createElement(EditableNote, {
      className: className,
      dateFormat: dateFormat,
      showTimezone: showTimezone,
      note: note,
      onCancel: onCancel,
      onChange: onChange,
      onSave: onSave,
      rows: rows,
      saving: saving,
      saveLabel: saveLabel,
      savingLabel: savingLabel
    });
  }

  return /*#__PURE__*/React.createElement(Card, {
    className: className
  }, /*#__PURE__*/React.createElement(NoteHeader, {
    note: note,
    dateFormat: dateFormat,
    showTimezone: showTimezone,
    onDelete: onDelete,
    onEdit: onEdit
  }), /*#__PURE__*/React.createElement(CardBody, null, /*#__PURE__*/React.createElement(CardText, {
    style: {
      whiteSpace: 'pre-wrap'
    }
  }, text), children));
};

Note.displayName = "Note";
Note.displayName = 'Note';
Note.defaultProps = defaultProps;
export default Note;